import { 
	Checkbox,
	Divider,
	Flex,
	IconButton,
	Image,
	Menu,
	MenuButton,
	MenuItem,
	MenuList,
	Stack,
	Text
} from '@chakra-ui/react';
import { FiMoreVertical } from 'react-icons/fi';

import { useAuth } from '../../../hooks/auth';
import { FinJsonDTO } from '../../../dtos/FinJsonDTO';
import { TituloDTO } from '../../../dtos/TituloDTO';

type ControlsData = {
	page: number;
	perPage: number;
	totalPage: number;
};

interface DTCardsParams {
	controls: ControlsData;
	titulos: TituloDTO[];
	setTituloModal: (product: FinJsonDTO) => void;
	setModalTituloVisible: (open: boolean) => void;
	setModalTituloEditVisible: (open: boolean) => void;
	setModalTituloDeleteVisible: (open: boolean) => void;
	titulosBaixa: FinJsonDTO[];
	setTitulosBaixa: (titulos: FinJsonDTO[]) => void;
	parcsBaixa: string[];
	setParcsBaixa: (id_baixa: string[]) => void;
	pagesBaixa: number[];
	setPagesBaixa: (page: number[]) => void;
};

const DTCards: React.FC<DTCardsParams> = ({
	controls,
	titulos,
	setTituloModal,
	setModalTituloVisible,
	setModalTituloEditVisible,
	setModalTituloDeleteVisible,
	titulosBaixa,
	setTitulosBaixa,
	parcsBaixa,
	setParcsBaixa,
	pagesBaixa,
	setPagesBaixa,
}) => {
	const { permissions } = useAuth();

	function handleCkeckbox(value: boolean, titulo: TituloDTO, id_parcela: string) {
		const indexParcela = titulo.fin_json.parcelas.findIndex(parc => parc.id === id_parcela);
		const parcela = titulo.fin_json.parcelas[indexParcela];

		if (value) {
			const indexTitulo = titulosBaixa.findIndex(item => item.id === titulo.id);

			if (indexTitulo !== -1) {
				const auxTitulosBaixa = titulosBaixa;
				// auxTitulosBaixa[indexTitulo].fin_json.parcelas.push(parcela);
				auxTitulosBaixa[indexTitulo].parcelas.push(parcela);

				setParcsBaixa([...parcsBaixa, id_parcela]);
				setTitulosBaixa([...auxTitulosBaixa]);
				return;
			};

			const auxTitulosBaixa = titulosBaixa;
			const auxTitulo = titulo;
			auxTitulo.fin_json.parcelas = [parcela];
			// auxTitulosBaixa.push(auxTitulo);
			auxTitulosBaixa.push(auxTitulo.fin_json);

			setParcsBaixa([...parcsBaixa, id_parcela]);
			setTitulosBaixa([...auxTitulosBaixa]);
		} else {

			const auxTitulosBaixa = titulosBaixa;

			const auxParcsBaixa = parcsBaixa.filter((item: string) => item !== id_parcela);
			setParcsBaixa([...auxParcsBaixa]);
			// setParcsBaixa((current: string[]) => current.filter((item: string) => item !== id_parcela));

			const indexTitulo = auxTitulosBaixa.findIndex(item => item.id === titulo.id);

			// if (auxTitulosBaixa[indexTitulo].fin_json.parcelas.length > 1) {
			if (auxTitulosBaixa[indexTitulo].parcelas.length > 1) {
				// const indexParcel = auxTitulosBaixa[indexTitulo].fin_json.parcelas.findIndex(item => item.id === id_parcela);
				// const auxParcelas = auxTitulosBaixa[indexTitulo].fin_json.parcelas;
				const indexParcel = auxTitulosBaixa[indexTitulo].parcelas.findIndex(item => item.id === id_parcela);
				const auxParcelas = auxTitulosBaixa[indexTitulo].parcelas;
				auxParcelas.splice(indexParcel, 1);

				// auxTitulosBaixa[indexTitulo].fin_json.parcelas = auxParcelas;
				auxTitulosBaixa[indexTitulo].parcelas = auxParcelas;

				setTitulosBaixa([...auxTitulosBaixa]);
				return;
			};

			auxTitulosBaixa.splice(indexTitulo, 1);
			setTitulosBaixa([...auxTitulosBaixa]);
		};
	};

	async function handleCheckAll(value: boolean) {
		if (value) {
			const filtered_array = titulosBaixa;

			// Filtra somente as que não existem no array de baixa
			for (let i = 0; i < titulos.length; i++) {
				const indexTitulo = filtered_array.findIndex(titulo => titulo.id === titulos[i].id);
				if (indexTitulo === -1) {
					// filtered_array.push(titulos[i]);
					filtered_array.push(titulos[i].fin_json);
				} else {
					// filtered_array[indexTitulo].fin_json.parcelas = titulos[i].fin_json.parcelas;
					filtered_array[indexTitulo].parcelas = titulos[i].fin_json.parcelas;
				};
			};

			setTitulosBaixa([...filtered_array]);
			// setPagesBaixa((oldArray: number[]) => [...oldArray, controls.page]);
			setPagesBaixa([...pagesBaixa, controls.page]);

			// Filtra somente as parcelas que não existe no array de baixa
			for (let i = 0; i < filtered_array.length; i++) {
				// for (let j = 0; j < filtered_array[i].fin_json.parcelas.length; j++) {
				for (let j = 0; j < filtered_array[i].parcelas.length; j++) {
					// const indexParcBaixa = parcsBaixa.findIndex(item => item === filtered_array[i].fin_json.parcelas[j].id);
					const indexParcBaixa = parcsBaixa.findIndex(item => item === filtered_array[i].parcelas[j].id);
					if (indexParcBaixa === -1) {
						const auxParcsBaixa = parcsBaixa;
						// auxParcsBaixa.push(filtered_array[i].fin_json.parcelas[j].id);
						auxParcsBaixa.push(filtered_array[i].parcelas[j].id);

						// setParcsBaixa((oldArray: any[]) => [...oldArray, filtered_array[i].fin_json.parcelas[j].id]);
						setParcsBaixa([...auxParcsBaixa]);
					};
				};
			};
		} else {
			const auxTitulosBaixa = titulosBaixa;
			const auxParcsBaixa = parcsBaixa;

			for (let i = 0; i < titulos.length; i++) {
				for (let j = 0; j < titulos[i].fin_json.parcelas.length; j++) {
					// se Existir a parcela, exclui
					const indexParcBaixa = auxParcsBaixa.findIndex(item => item === titulos[i].fin_json.parcelas[j].id);
					if (indexParcBaixa >= 0) {
						auxParcsBaixa.splice(indexParcBaixa, 1);
					};
				};
				// se exixtir o titulo, exclui
				const indexTitulo = titulosBaixa.findIndex(item => item.id === titulos[i].id);
				if (indexTitulo >= 0) {
					auxTitulosBaixa.splice(indexTitulo, 1);
				};
			};

			setTitulosBaixa([...auxTitulosBaixa]);
			setParcsBaixa([...auxParcsBaixa]);

			const indexPageBaixa = pagesBaixa.findIndex(page => page === controls.page);
			const auxPagesBaixa = pagesBaixa;
			auxPagesBaixa.splice(indexPageBaixa, 1);
			setPagesBaixa([...auxPagesBaixa]);
		};
	};

  return (
    <Flex w="100%" flexDir="column" justify="center" align="center">
			<Flex w="100%" px={2} align="center">
				<Checkbox
					isChecked={pagesBaixa.includes(controls.page)}
					onChange={(e: any) => handleCheckAll(e.target.checked)}
				/>
				<Text fontWeight={500} ml={1}>Todos</Text>
			</Flex>

      {titulos.map(titulo => {
        return (
          <Flex
						key={titulo.id_parcela}
            w="100%"
            bgGradient="linear(to-r, gray.50, gray.100)"
            borderRadius={8}
            boxShadow="xl"
            p="4"
						pr="2"
						m={["2", "4"]}
          >
						<Flex w="100%">
							<Flex h="100%" flexDir="column" justify="flex-start" pt={1} pr={4}>
								<Checkbox
									isChecked={parcsBaixa.includes(titulo.id_parcela)}
									onChange={(e: any) => handleCkeckbox(e.target.checked, titulo, titulo.id_parcela)}
								/>
							</Flex>

							<Flex w="100%">
								{titulo.id && (
									<Flex flexDir="column" w="90%">
										{/* NOME */}
										<Flex w="100%" justify="space-between">
											{titulo.nome && (
												<Text
													color="blue.500"
													textTransform="uppercase"
													fontWeight="500"
													fontSize="14"
												>
													{titulo.nome}
												</Text>
											)}
										</Flex>
										{/* PARCELA - PAY */}
										<Flex flexDir={["column", "row"]} justify={["flex-start", "space-between"]}>
											{/* PARCELA */}
											<Flex fontSize={["12", "14"]} fontWeight={500} color="gray.600" w="100%">
												<Text>Parcela:</Text>&nbsp;
												<Text color="gray.800">{titulo.parcela}</Text>
											</Flex>

											{/* PAY */}
											<Flex fontSize={["12", "14"]} fontWeight={500} color="gray.600" w="100%">
												{titulo.url_pay && (
													<Image src={titulo.url_pay} objectFit='cover' w='25px' h="20px" mr={2} />
												)}

												<Text
													color="gray.800"
													fontWeight="500"
													fontSize="14"
												>
													{titulo.name_pay}
												</Text>
											</Flex>
										</Flex>

										{/* VLR CRÉDITO - VLR DÉBITO */}
										<Flex flexDir={["column", "row"]} justify={["flex-start", "space-between"]} mt={1}>
											{/* VLR CRÉDITO */}
											<Flex fontSize={["12", "14"]} fontWeight={500}	color="gray.600" w="100%">
												<Text>Vlr Crédito:</Text>&nbsp;
												<Text color="gray.800">{titulo.vlr_cred_formatted}</Text>
											</Flex>
											
											{/* VLR DÉBITO */}
											<Flex fontSize={["12", "14"]} fontWeight={500} color="gray.600" w="100%">
												<Text>Vlr Débito:</Text>&nbsp;
												<Text color="gray.800">{titulo.vlr_deb_formatted}</Text>
											</Flex>
										</Flex>

										{/* AMORTIZADO - DESCONTO */}
										<Flex flexDir={["column", "row"]} justify={["flex-start", "space-between"]} mt={1}>
											{/* AMORTIZADO */}
											<Flex fontSize={["12", "14"]} fontWeight={500} color="gray.600" w="100%">
												<Text>Amortizado: </Text>&nbsp;
												<Text color="gray.800">{titulo.amortizado_formatted}</Text>
											</Flex>
											{/* DESCONTO */}
											<Flex fontSize={["12", "14"]} fontWeight={500} color="gray.600" w="100%">
												<Text>Desconto: </Text>&nbsp;
												<Text color="gray.800">{titulo.desconto_formatted}</Text>
											</Flex>
										</Flex>

										{/* JUROS - MULTA */}
										<Flex flexDir={["column", "row", "row"]} justify={["flex-start", "space-between"]} mt={1}>
											{/* JUROS */}
											<Flex fontSize={["12", "14"]}  fontWeight={500} color="gray.600" w="100%">
												<Text>Juros: </Text>&nbsp;
												<Text color="gray.800">{titulo.juros_formatted}</Text>
											</Flex>
											{/* MULTA */}
											<Flex fontSize={["12", "14"]}  fontWeight={500} color="gray.600" w="100%">
												<Text>Multa: </Text>&nbsp;
												<Text color="gray.800">{titulo.multa_formatted}</Text>
											</Flex>
										</Flex>

										{/* PAGO - DATA BAIXA */}
										<Flex flexDir={["column", "row"]} justify={["flex-start", "space-between"]} mt={1}>
											{/* PAGO */}
											<Flex fontSize={["12", "14"]}  fontWeight={500} color="gray.600" w="100%">
												<Text>Pago: </Text>&nbsp;
												<Text color="gray.800">{titulo.pago_formatted}</Text>
											</Flex>
											{/* DATA BAIXA */}
											<Flex fontSize={["12", "14"]} fontWeight={500} color="gray.600" w="100%">
												<Text>Data Baixa: </Text>&nbsp;
												<Text color="gray.800">
													{titulo.data_baixa ? titulo.data_baixa : '--'}
												</Text>
											</Flex>
										</Flex>

										{/* SALDO CRÉD. - SALDO DÉBb */}
										<Flex flexDir={["column", "row"]} justify={["flex-start", "space-between"]} mt={1}>
											{/* SALDO CRÉD. */}
											<Flex fontSize={["12", "14"]} fontWeight={500} color="gray.600" w="100%">
												<Text>Saldo Créd:</Text>&nbsp;
												<Text color="gray.800">{titulo.saldo_cred_formatted}</Text>
											</Flex>
											{/* SALDO DÉB. */}
											<Flex fontSize={["12", "14"]} fontWeight={500} color="gray.600" w="100%">
												<Text>Saldo Déb:</Text>&nbsp;
												<Text color="gray.800">{titulo.saldo_deb_formatted}</Text>
											</Flex>
										</Flex>

										{/* DATA - VENCIMENTO */}
										<Flex flexDir={["column", "row"]} justify={["flex-start", "space-between"]} mt={1}>
											{/* DATA */}
											<Flex fontSize={["12", "14"]} fontWeight={500} color="gray.600" w="100%">
												<Text>Data:</Text>&nbsp;
												<Text color="gray.800">{titulo.data}</Text>
											</Flex>
											{/* VENCIMENTO */}
											<Flex fontSize={["12", "14"]} fontWeight={500} color="gray.600" w="100%">
												<Text>Vencimento:</Text>&nbsp;
												<Text color="gray.800">{titulo.vencimento}</Text>
											</Flex>
										</Flex>
									</Flex>
								)}

								{/* MENU */}
								<Flex flexDir="column" justify="flex-end">
									<Menu>
										{({ isOpen }) => (
											<>
												<MenuButton
													border={0}
													fontSize="1.5626rem"
													as={IconButton}
													isActive={isOpen}
													aria-label="Options"
													icon={<FiMoreVertical />}
													variant="outline"
													_hover={{ bg: 'gray.50' }}
												/>

												<MenuList p={0} boxShadow='xl'>
													<MenuItem
														fontSize={16}
														fontWeight={500}
														py={3}
														_hover={{ bg: 'gray.50' }}
														onClick={() => {
															setTituloModal(titulo.fin_json);
															setModalTituloVisible(true);
														}}
													>
														Detalhes
													</MenuItem>

													{permissions.alterar && (
														<>
															<Divider />

															<MenuItem
																fontSize={16}
																fontWeight={500}
																py={3}
																_hover={{ bg: 'gray.50' }}
																onClick={() => {
																	setTituloModal(titulo.fin_json);
																	setModalTituloEditVisible(true);
																}}
															>
																Editar
															</MenuItem>
														</>
													)}

													{permissions.excluir && (
														<>
															<Divider />

															<MenuItem
																fontSize={16}
																fontWeight={500}
																py={3}
																_hover={{ bg: 'gray.50' }}
																onClick={() => {
																	setTituloModal(titulo.fin_json);
																	setModalTituloDeleteVisible(true);
																}}
															>
																Excluir
															</MenuItem>
														</>
													)}
												</MenuList>
											</>
										)}
									</Menu>
								</Flex>
							</Flex>
            </Flex>
          </Flex>
        );
      })}
    </Flex>
  );
};

export default DTCards;
